import React, { useMemo } from "react";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { useFlatDocumentCategories } from "@api/documentCategory.api";
import { DocumentCategoryIcon } from "./DocumentCategoryIcon";
import styles from "./DocumentCategoryDisplay.module.scss";

interface Props {
    documentCategoryId: string;
}

export const DocumentCategoryDisplay: React.FC<Props> = ({
    documentCategoryId,
}) => {
    const allCategories = useFlatDocumentCategories();
    const category = useMemo(
        () => allCategories.find((c) => c.id === documentCategoryId) ?? null,
        [allCategories, documentCategoryId],
    );

    if (!category) {
        return (
            <span className={styles.container}>
                <BreakableText text={documentCategoryId} />
            </span>
        );
    }

    return (
        <span className={styles.container}>
            <DocumentCategoryIcon
                documentTaxonomy={category.documentTaxonomy}
            />
            <span className={styles.name}>
                <BreakableText text={category.label} showTooltip />
            </span>
        </span>
    );
};
